export const projects = [
  {
    title: "Builders",
    description: "VCNR Builders offers end-to-end building solutions across residential, commercial, industrial, and public infrastructure projects. From individual homes to large-scale developments like logistics parks, we don’t just build structures - we build what the future needs.",
    src: "vcnrbuildercard.jpg",
    logo: "whitelogo.svg",
    link: "/Builders",
    color: "#BBACAF"
  },
  {
    title: "Healthcare",
    description: "VCNR Healthcare was established with a clear purpose: to make quality healthcare affordable, accessible, and accountable to all, irrespective of geography or income. ",
    src: "vcnrhealthcarecard.png",
    logo: "whitelogo.svg",
    link: "/Healthcare",
    color: "#B62429"
  },
    {
    title: "Technologies",
    description: "Our technology platforms deliver future-ready solutions across industries, pushing the boundaries of digital innovation.",
    src: "vcnrtechnologiescard.png",
    logo: "whitelogo.svg",
    link: "/Technologies",
    color: "#88A28D"
  },
    
  {
    title: "Gold and Diamonds",
    description: "Welcome to VCNR Golds and Diamonds – a place where tradition meets craftsmanship. From best gold manufacturers to your everyday diamond studs, we create more than jewelry, we craft memories.",
    src: "vcnrgolds.png",
    logo: "whitelogo.svg",
    link: "/Goldandiamonds",
    color: "#C2491D"
  },
  {
    title: "Educational Institutions",
    description: "VCNR Educational Institutions believe that education is the cornerstone of societal progress. By integrating academic excellence with practical skill development, our institutions aim to nurture a generation of leaders capable of driving positive change and shaping a better future for every community they serve.",
    src: "vcnredu.png",
    logo: "whitelogo.svg",
    link: "/educational",
    color: "#88A28D"
  },
  {
    title: "Properties",
    description: "VCNR Properties creates sustainable and innovative spaces that enrich communities and lives.",
    src: "vcnrprop.png",
    logo: "whitelogo.svg",
    link: "/Properties",
    color: "#88A28D"
  },

  {
    title: "Hospitality",
    description: "Welcome to VCNR Resorts, a sanctuary of peace and  greenery. Crafted for relaxation, celebration, and reconnection. Come to relax and reconnect with your loved ones, or celebrate a milestone. More than just a stay, We offer soul-soothing experiences.",
    src: "vcnrhospitalilties.png",
    logo: "whitelogo.svg",
    link: "/Hospitality",
    color: "#88A28D"
  },
  {
    title: "Agrotech",
    description: "CNR Agrotech was born from the VCNR Group’s belief in innovation led growth, a growth that is designed to grow with purpose, compassion, and lasting value Since becoming an independent agri-tech vertical in 2021, we have focused on farmer-first solutions that make a difference.",
    src: "vcnragrotechcard.png",
    logo: "whitelogo.svg",
    link: "/Agrotech",
    color: "#88A28D"
  },

  {
    title: "Hitachinthana Charitable Trust",
    description: "Hitachinthana Charitable Trust lies at the heart of our purpose. Dedicated to rural development, wellness, education, and sustainability, the Trust drives meaningful change that uplifts lives, strengthens communities, and empowers humanity with compassion and care.",
    src: "vcnrtrust.png",
    logo: "",
    link: "/Foundation",
    color: "#88A28D"
  }
]